// extracted by mini-css-extract-plugin
export default {"cardInfo":"CardInfo_cardInfo__XYE1u","cardInfo__title":"CardInfo_cardInfo__title__1UY8K","cardInfo__subtitle":"CardInfo_cardInfo__subtitle__NlAR0"};